module.exports = __webpack_public_path__ + "img/Raspberry32_48.55d6a0d4.png";